import Colaborador from '../types/negocio/Colaborador';
import api from './api';
import BaseService from './BaseService';

class ColaboradorService extends BaseService<Colaborador> {
 
  constructor() {
    super('colaborador', api);
  }
  
}

export const colaboradorService = new ColaboradorService();